module.exports = __webpack_public_path__ + "img/wxjy.8f9a7f8d.png";